export const METERS = 'meters';
export const CONED = 'coned';
export const UTILITY_BILLS = 'utility-bills';
export const DATA_SOURCES = [METERS, CONED, UTILITY_BILLS];
